export const invoiceTemplates = {
  breadcrumb: {
    overview: 'Factuurtemplates',
    noTitle: 'Geen titel',
    create: 'Factuurtemplate aanmaken',
  },
  actions: {
    create: 'Factuurtemplate aanmaken',
    createInvoice: 'Factuur maken',
    delete: 'Verwijderen',
    details: 'Meer details',
    edit: 'Bewerken',
    pause: 'Pauzeren',
    unpause: 'Live zetten',
  },
  alerts: {
    successCreated: 'Je factuurtemplate werd succesvol aangemaakt!',
    successDeleted: 'Je factuurtemplate werd succesvol verwijderd!',
    successUpdated: 'Je factuurtemplate werd succesvol gewijzigd!',
  },
  breadcrumbs: {
    index: 'Alle factuurtemplates',
    show: 'Factuurtemplate details',
  },
  createEdit: {
    blocker: {
      create: 'Ben je zeker dat je de pagina wilt verlaten? Je factuurtemplate werd nog niet aangemaakt.',
      edit: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je factuurtemplate werden nog niet opgeslagen.',
    },
    fields: {
      interval: {
        label: 'Herhaling',
      },
      nextInvoiceAt: {
        label: 'Eerstvolgende factuur',
      },
      paymentTerm: {
        helpText: 'De vervaldatum zal {{days}} dagen na de factuurdatum zijn.',
        helpTextEndOfMonth: 'De vervaldatum zal {{days}} dagen na het einde van de maand van de factuurdatum zijn.',
      },
    },
    header: {
      title: {
        create: 'Nieuwe factuurtemplate',
        edit: 'Bewerk factuurtemplate',
      },
    },
    preview: 'Voorbeeld factuur',
    unpauseModal: {
      description:
        'Deze factuurtemplate is momenteel niet actief.<break/>\nWil je deze opnieuw activeren? De volgende factuur zou op {{nextInvoiceAt}} aangemaakt worden.',
      keepPaused: 'Inactief laten',
      title: 'Periodiek factureren hervatten',
      unpause: 'Opnieuw activeren',
    },
  },
  deleteModal: {
    description: 'Weet je zeker dat je deze factuurtemplate wilt verwijderen?',
    submit: 'Verwijder factuurtemplate',
    title: 'Factuurtemplate verwijderen',
  },
  details: {
    error: {
      title: 'Fout bij het laden van je factuurtemplate',
    },
    intervalStatusTooltip: {
      Live: 'Deze factuurtemplate is actief. Facturen worden periodiek aangemaakt.',
      Paused: 'Deze factuurtemplate is momenteel niet actief. Facturen worden niet periodiek aangemaakt.',
    },
    invoices: {
      noInvoicesMessage: 'Er werden nog geen facturen gemaakt met deze factuurtemplate.',
      title: 'Facturen',
      titleWithCount: 'Facturen ({{amount}})',
    },
    stats: {
      nextInvoice: {
        label: 'Volgende factuur',
        tooltip: 'Op deze dag wordt er automatisch een nieuwe conceptfactuur voor je aangemaakt, op basis van deze template.',
      },
      recurring: {
        label: 'Periodiek aanmaken',
        tooltip: 'De frequentie waarmee facturen worden aangemaakt.',
      },
      totalAdvantage: {
        label: 'Totaal voordeel',
        tooltip: 'Het totale voordeel van alle facturen die je gemaakt hebt met deze template.',
      },
      totalInvoices: {
        label: 'Aantal facturen',
        tooltip: 'Totaal aantal facturen dat werd aangemaakt op basis van deze factuurtemplate.',
      },
    },
    summary: {
      title: 'Overzicht',
    },
  },
  overview: {
    columns: {
      client: 'Klant',
      nextInvoiceAt: 'Volgende factuur',
      title: 'Titel',
      total: 'Totaal (excl. btw)',
      type: 'Type',
    },
    error: {
      title: 'Fout bij het laden van je factuurtemplates',
    },
    header: {
      title: 'Factuurtemplates',
    },
  },
  terminology: {
    interval: {
      cases: {
        Disabled: 'Uitgeschakeld',
        Monthly: 'Maandelijks',
        Quarterly: 'Ieder kwartaal',
        Weekly: 'Wekelijks',
      },
    },
    intervalStatus: {
      cases: {
        Live: 'Live',
        Paused: 'Pauze',
      },
    },
    invoiceTemplate: 'Factuurtemplate',
    templateType: {
      cases: {
        Manual: 'Manueel',
        Recurring: 'Periodiek',
      },
    },
  },
};
